<template>
  <div
    class="hero-container"
    :style="{ 'background-image': 'url(' + titleImage + ')' }"
  >
    <!--      <video id="hero-video" autoplay loop muted  @mouseenter="setCursor(-->
    <!--      imgTag,-->
    <!--      scrollTo,-->
    <!--      {'font-size': '34px', width: '100px', height: '100px',  cursor: 'none' })">-->
    <!--          <source src="/video/VIDEO_HERO_SECTION.mp4" type="video/mp4">-->
    <!--          Your browser does not support the video tag.-->
    <!--      </video>-->
    <Navbar
      @mouseover="
        setCursor(null, null, {
          'font-size': '14px',
          cursor: 'unset',
          'z-index': '1',
          width: '25px',
          height: '25px',
        })
      "
    />
    <div
      class="max-w-7xl w-full h-screen absolute top-0 left-1/2 -translate-x-1/2 pointer-events-none"
    >
      <div class="relative w-full h-full">
        <HeroTextEditable :text="title" :width="width" />
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
export default {
  name: "Hero",
  props: {
    setCursor: {
      required: true,
      type: Function,
    },
    titleImage: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    width: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      imgTag: '<img src="/img/ArrowDown.png" />',
    };
  },
  methods: {
    scrollTo() {
      gsap.registerPlugin(ScrollToPlugin);
      gsap.to(window, { duration: 1, scrollTo: "#bubbles" });
    },
  },
};
</script>

<style scoped>
.hero-container {
  position: relative;
  height: 100vh;
  width: 100vw;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("../assets/hero.png");
	background-position: center;

  cursor: none;
}

#hero-video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  object-fit: cover;
}
</style>
